import { startOfDay } from 'date-fns';
import { removeTimeZoneOffset } from './removeTimeZoneOffset';

export function startOfDayUtc(date: Date) {
  return removeTimeZoneOffset(startOfDay(date));
}
